/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1.5A3.75 3.75 0 0 0 8.25 5.25v7.5a3.75 3.75 0 0 0 7.5 0v-7.5A3.75 3.75 0 0 0 12 1.5ZM9.75 5.25a2.25 2.25 0 0 1 4.5 0v7.5a2.25 2.25 0 0 1-4.5 0v-7.5Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M5.25 12a.75.75 0 0 0-1.5 0 8.25 8.25 0 0 0 7.5 8.2246V22.5h-2.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-2.25v-2.2754A8.25 8.25 0 0 0 20.25 12a.75.75 0 0 0-1.5 0 6.75 6.75 0 0 1-13.5 0Z"
    />
  </React.Fragment>,
  'MenuVoice'
);
